import { isNativeMobileApp } from '../mobile';

export const isDarkMode = () =>
  window.matchMedia &&
  window.matchMedia( '(prefers-color-scheme: dark)' ).matches &&
  isNativeMobileApp();

// A whitelabel theme sheet that paints its storefront dark declares
// `color-scheme: dark`. Stripe renders inside iframes that cannot read the
// page's styles, so its elements are told the same thing from here.
export const isDarkPage = () =>
  getComputedStyle( document.documentElement ).getPropertyValue( 'color-scheme' ).trim() === 'dark';

export const prefersDarkPayments = () => isDarkMode() || isDarkPage();

// A color the dark storefront's theme sheet sets as a custom property, for
// handing to Stripe. Undefined on any other page, so callers keep their own.
export const darkPageColor = ( property: string ) =>
  ( isDarkPage() && getComputedStyle( document.documentElement ).getPropertyValue( property ).trim()) ||
  undefined;
